import React, { useState, useEffect, useRef } from 'react'
import { createPortal } from 'react-dom';
import { useWorkStateFields, useStateFields } from '../../store/hooks';
import Navbar from '../../components/Navbar/Navbar'
import {
    Accordion, AccordionItem, AccordionButton, AccordionPanel,
    AccordionIcon, Badge, Divider, useDisclosure, Card, Image
} from '@chakra-ui/react'
import { MdPhoneCallback, MdOutlineAddPhotoAlternate, MdOutlinePayment, MdOutlineLibraryBooks } from "react-icons/md";
import { getPhEventType, getQueryVariable, GetProfile, getLoginPage, getAuthToken, getAPIUrl, token_url,
         isAdmin, quotation_string, getWhatsappShareUrl, globalLoader, Platform, downloadReceipt, 
         catchError, get_platform_bg_color, setNavigationHistory, handleActivity, shouldShowPlayStoreInstallBanner, dismissPlayStoreInstallBanner, openPlayStoreOrInstallApp } from '../../script/util.js';
import { openExternalApp } from '@egreact/shared';
import './Dashboard.css'
import axios from 'axios';
import { FaPhotoVideo } from "react-icons/fa";
import { BiUserCheck } from "react-icons/bi";
import { AiOutlineVideoCameraAdd } from "react-icons/ai";
import { Link, useLocation } from 'react-router-dom';
import {
    Table, Tbody, Tr, Th, Td
} from '@chakra-ui/react'
import { TfiReload } from "react-icons/tfi";
import { BiUnlink } from "react-icons/bi";
import { FaWhatsapp } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { useLayoutEffect } from "react";
import CopyButton from '../../components/CopyButton';
import { AlertDialog, AlertDialogBody, AlertDialogFooter, AlertDialogHeader, AlertDialogContent, AlertDialogOverlay } from '@chakra-ui/react'
import * as CONST from "../../script/const.js";
import ShareButton from 'react-share/lib/ShareButton';
import Popup from '../../components/Popup/Popup.js';
import DownloadIcon from "../../images/download.png";
import { GiStarsStack } from "react-icons/gi";
import { AiOutlineClose } from "react-icons/ai";
import { Toast } from '@egreact/shared';
import WorkDetailHeader from '../WorkDetail/WorkDetailHeader';
import { getCurrentPage } from '../WorkDetail/work_utils';
import StoreToken from '../../components/StoreToken';
import GoogleRatingPopup from '../../components/GoogleRatingPopup/GoogleRatingPopup';
import Banner from '../../components/Banner/Banner';
import BookingCountdown from './BookingCountdown';
// import award1 from "../EGQuotation/Quotation_images/badge-runnerup(2024).png"    INSTA changes
// import award2 from "../EGQuotation/Quotation_images/WMG-badge.png"   INSTA changes
// import award3 from "../EGQuotation/Quotation_images/WS-badge.png"    INSTA changes
// import { motion } from "framer-motion";  INSTA changes
// import { FaPlay } from "react-icons/fa"; INSTA changes

// import { InstagramEmbed } from 'react-social-media-embed';   INSTA changes

// const fetchInstagramPosts = async () => {    INSTA changes
//     try {
//         var insta_url = `${process.env.REACT_APP_STAG_URL}/api/work/instagram/`;

//         const response = await axios.get(insta_url, {
//             headers: {
//                 Authorization: getAuthToken(),
//             },
//         });

//         if(!response.data.success){
//             throw new Error("Error fetching Instagram data");
//         }
//         return response.data.instagram_data; 
//     } catch (error) {
//         return []; 
//     }
// };
  


// const images = [ award1, award2, award3];    INSTA changes


// EG-1599. `creative_preference` is null when no form applies (no wedding, or
// nothing finalized) — render nothing at all in that case, not a disabled state.

// The API returns an absolute URL. Keep same-origin links inside the SPA so the
// app does not full-page reload; send anything else out as a plain link. Both
// client form links go through it.
const creativePreferenceTarget = (url) => {
    try {
        const parsed = new URL(url, window.location.origin);
        if (parsed.origin === window.location.origin) return { to: parsed.pathname + parsed.search };
        return { href: url };
    } catch (e) {
        return { href: url };
    }
};

// Both forms live in the same corner of the card, so they are one control
// with a list behind it rather than two tiles fighting for the same spot.
const FormsTile = ({ creative, weddingDay, whatToExpect }) => {
    const [open, setOpen] = useState(false);
    // A phone has no room beside the tile, so the list comes up from the
    // bottom of the screen the way the rest of the app's sheets do.
    const [isPhone, setIsPhone] = useState(
        () => typeof window !== 'undefined'
            && window.matchMedia('(max-width: 900px)').matches
    );
    useEffect(() => {
        const query = window.matchMedia('(max-width: 900px)');
        const read = () => setIsPhone(query.matches);
        query.addEventListener('change', read);
        return () => query.removeEventListener('change', read);
    }, []);
    const rows = [];
    if (creative) {
        rows.push({
            key: 'creative',
            label: 'Creative Preference Form',
            data: creative,
            state: CONST.CREATIVE_PREFERENCE_STATES[creative.status]
                || CONST.CREATIVE_PREFERENCE_STATES['not started'],
        });
    }
    if (weddingDay) {
        rows.push({
            key: 'wedding-day',
            label: 'Wedding Day Details',
            data: weddingDay,
            state: CONST.WEDDING_DAY_STATES[weddingDay.status]
                || CONST.WEDDING_DAY_STATES['not started'],
        });
    }
    if (whatToExpect) {
        rows.push({
            key: 'what-to-expect',
            label: 'What to Expect',
            data: whatToExpect,
            state: CONST.WEDDING_DAY_STATES[whatToExpect.status]
                || CONST.WEDDING_DAY_STATES['not started'],
        });
    }
    if (!rows.length) return null;
    // The card itself navigates, so nothing in here may reach it.
    const stop = (e) => e.stopPropagation();
    // Hung off the body on a phone: the card is positioned and clipped, so
    // a sheet left inside it cannot reach the foot of the screen.
    const wrap = (list) => (isPhone
        ? createPortal(
            <div className='pref-sheet' onClick={(e) => { stop(e); setOpen(false); }}>
                {list}
            </div>,
            document.body
        )
        : list);
    return (
        <div
            className='pref-link pref-menu'
            onClick={(e) => { stop(e); setOpen((v) => !v); }}
        >
            <span className='pref-link__text'>
                <span className='pref-link__label'>Preference Forms</span>
                <span className='pref-link__meta'>
                    {rows.length === 1 ? '1 form' : `${rows.length} forms`}
                </span>
            </span>
            <span className='pref-menu__chev'>{open ? '\u25B4' : '\u25BE'}</span>
            {open ? wrap(
                <div className='pref-menu__list' onClick={stop}>
                    {isPhone ? (
                        <p className='pref-menu__title'>Preference Forms</p>
                    ) : null}
                    {rows.map((row) => {
                        const target = creativePreferenceTarget(row.data.url);
                        const inner = (
                            <span className='pref-link__text'>
                                <span className='pref-link__label'>{row.label}</span>
                                <span className='pref-link__meta'>{row.state.meta}</span>
                                <BookingCountdown
                                    locksAt={row.data.locks_at}
                                    locked={row.data.locked}
                                />
                            </span>
                        );
                        return target.to ? (
                            <Link
                                key={row.key}
                                className={`pref-menu__item ${row.state.className}`}
                                to={target.to}
                                onClick={stop}
                            >{inner}</Link>
                        ) : (
                            <a
                                key={row.key}
                                className={`pref-menu__item ${row.state.className}`}
                                href={target.href}
                                onClick={stop}
                            >{inner}</a>
                        );
                    })}
                </div>
            ) : null}
        </div>
    );
};

const Dashboard = () => {
    const { storeToLocal } = StoreToken();
    
    document.title = "Dashboard | EventGraphia";
    if (Platform.isWG) {
        document.title = "Dashboard | WedGraphia"
    }
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true)
    const [downloadingReceiptId, setDownloadingReceiptId] = useState(null)
    const handleDownloadReceipt = async (installmentId, filename) => {
        if (!installmentId) return
        if (downloadingReceiptId) return
        try {
            setDownloadingReceiptId(installmentId)
            await downloadReceipt(installmentId, filename)
        } finally {
            setDownloadingReceiptId(null)
        }
    }
    const { isLoggedin, setisLoggedin, pages, phTrack, posthogEvents } = useStateFields(['isLoggedin', 'pages', 'phTrack', 'posthogEvents']);
    const divRef = useRef(null)
    const {  onOpen, onClose } = useDisclosure();
    const [paydetail, setpaydetail] = useState("loading..")
    const [openShare, setopenShare] = useState(false)
    const [openEventDetail, setopenEventDetail] = useState(false)
    const [bookings, setbookings] = useState([])
    const [bookingDetail, setbookingDetail] = useState([{}])
    const [eventDetailPopup, seteventDetailPopup] = useState(null)
    const [paymentHistoryBookingId, setPaymentHistoryBookingId] = useState(null)
    const [sharePopup, setsharePopup] = useState(null)
    const [openpaymentHistory, setopenpaymentHistory] = useState(false)
    const [openedTabIndex, setOpenedTabIndex] = useState(-1);
    const cancelRef = React.useRef()
    const [onOpenAlert, setonOpenAlert] = useState(false)
    const [isRegConfirm, setisRegConfirm] = useState(false)
    const [shareDetailsArray, setShareDetailsArray] = useState({});
    const [sharePayloads, setSharePayloads] = useState({ bid: "", pk: "" });
    const [book_Pk, setBook_Pk] = useState()
    const [book_Id, setBook_Id] = useState()
    const [currId, setCurrId] = useState()
    const [dashWidth, setDashWidth] = useState()
    const [feedback, setFeedback] = useState({
        rating: null,
        feedbackText: '',
    })
    const [selectedBookingForRating, setSelectedBookingForRating] = useState(null);
    const [activityTab, setActivityTab] = useState(false)
    const [showAppBanner, setShowAppBanner] = useState(false);
    const currentPage = getCurrentPage(CONST, CONST.DASHBOARD);
    const { currentDimensions, setCurrentDimensions, showToast, setShowToast, toastMessage, setToastMessage } = useWorkStateFields(['currentDimensions', 'showToast', 'toastMessage']);
      const [showGooglePopup, setShowGooglePopup] = useState(false);

    const fetchBookings = () => {
        axios({
        method: 'get',
        url: getAPIUrl('/api/booking/all/'),
        headers: {
            Authorization: getAuthToken(),
        },
        dataType: 'json',
        cache: false,
        })
        .then((res) => {
            const tp = res.data;
            if (tp.success) {
            setLoading(false);
            setisLoggedin(true);
            setbookings([...tp.current_bookings, ...tp.past_bookings]);
            setActivityTab(tp.activity?.length > 0)
            }
        })
        .catch((error) => {
            catchError(error);
        });
    };
    // const [instaPosts, setInstaPosts] = useState(null);  INSTA changes
    // const [isMobile, setIsMobile] = useState(window.innerWidth < 768);   INSTA changes
    // const containerRef = useRef(null);   INSTA changes
    // const scrollerRef = useRef(null);    INSTA changes

    // const [isInstaPopupOpen, setIsInstaPopupOpen] = useState(false); INSTA changes
    // const [clickedInstaPost, setClickedInstaPost] = useState(null);  INSTA changes

    // useEffect(() => {    INSTA changes
    //   const handleResize = () => {   INSTA changes
    //     setIsMobile(window.innerWidth < 768);
    //   };
    //   window.addEventListener("resize", handleResize);   INSTA changes
    //   return () => window.removeEventListener("resize", handleResize);   INSTA changes
    // }, []);

    useLayoutEffect(() => {
        storeToLocal();
    }, []);

    useEffect(() => {
        if (isLoggedin) fetchBookings();
    }, [isLoggedin]);


    useEffect(() => {
        const handleResize = () => {
            setDashWidth(window.innerWidth);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

//     const InstaImageGrid = ({ instaResp }) => {  INSTA changes
//     let instaImages = instaResp.map((i) => { INSTA changes
//         if(i.media_type === "IMAGE" || i.media_type === "CAROUSEL_ALBUM") {
//             return {pic: i.media_url, link: i.permalink, type: i.media_type};
//         }else if(i.media_type === "VIDEO") {
//             return {pic: i.thumbnail_url, link: i.permalink, type: i.media_type};
//         }
//     })
//     return ( INSTA changes
//       <div className="image-grid">
//         {instaImages.map((img, index) => (
//             <div onClick={() => {setIsInstaPopupOpen(true); setClickedInstaPost(img.link)}} key={index}>
          
//             {
//                 img.type !== "VIDEO" ? (
//                     <div  className="image-container">
//                         <img src={img.pic} alt={`img-${index}`} />
//                     </div>
//                 ) : (
//                     <div  className="image-container">
//                         <img src={img.pic} alt={`img-${index}`} />
//                         <span style={{color: "whitesmoke"}}>
//                             <FaPlay />
//                         </span>
//                     </div>
//                 )
//             }
//             </div>
//         ))}
//       </div>
//     );
//   };

    const getShareDetail = async (booking_pk, bid) => {
        setLoading(true);
        setShareDetailsArray({})
        setBook_Pk(booking_pk)
        setBook_Id(bid)
        if (shareDetailsArray.hasOwnProperty(booking_pk)) {
            showShareDetails(booking_pk, bid);
            return;
        }
        if (booking_pk !== undefined) {
            try {
                const res = await axios.get(getAPIUrl(`/api/share/url/${booking_pk}/`), {
                    headers: {
                        Authorization: getAuthToken(),
                    },
                });

                const sharedCall = res.data;
                if (sharedCall.success) {
                    const updatedShareDetailsArray = { ...shareDetailsArray };
                    const x = sharedCall.shared_data;
                    updatedShareDetailsArray[booking_pk] = {
                        booking_id: bid,
                        shared_array: x,
                    }
                    setShareDetailsArray(updatedShareDetailsArray);
                    setSharePayloads({ bid: bid, pk: booking_pk })
                    { !sharePayloads.bid && <>{globalLoader()}</> }
                    sharePayloads.bid && showShareDetails(booking_pk, bid)
                }
            } catch (error) {
                catchError(error);
            }
        }
    };
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);

    const handleOrientationChange = () => {
        setCurrentDimensions(window.innerWidth)
    };

    const handleFeedbackSubmit = async () => {

        if(isAdmin()){
            return;
        }

        let unratedItem = selectedBookingForRating.nps_list.find(item => item.score == 0);
        let nps_id = unratedItem?.id;

        if(!feedback.rating){
            return;
        }

        const authToken = getAuthToken();
        const headers = {
          Authorization: authToken,
        };

        const ratingData = {
            score: feedback.rating,
            suggestion: feedback.feedbackText,
            disabled: true,
            editable: false,
            user_id: null,
            user_name: null
        }
        if (feedback.rating === 10) {
          setShowGooglePopup(true);
        }
        
        try {
            const response = await axios.post(
              `${process.env.REACT_APP_STAG_URL}/api/booking/user-ratings/update/${nps_id}/`,
              ratingData,
              { headers }
            );


            if (response.data.success) {
                let npsItem = response.data;
                let updatedNpsData = {
                  score: npsItem.score,
                  suggestion: npsItem.suggestion,
                  disabled: npsItem.score || false,
                  user_id: npsItem.user_id,
                  user_name: npsItem.user_name || false,
                  editable: false
                };
        
                setShowToast(true)
                setToastMessage(npsItem.toast_data)

                fetchBookings();
            } else {
            setShowToast(true)
            setToastMessage({'title': response.data.message})
            }

        } catch (error) {
            console.error(error);
        }    

        setSelectedBookingForRating(null);
        setFeedback({
            rating: null,
            feedbackText: ""
        })
      };

      const handleFeedbackClose = () => {
        setSelectedBookingForRating(null);
        setFeedback({
            rating: null,
            feedbackText: ""
        })
      }


      let selectedElement = null;

    document.addEventListener('mouseover', (event) => {
        if (
          event.target.classList.contains('raterNumber') &&
          event.target.classList.contains('raterNew') &&
          event.target !== selectedElement && !isAdmin()
        ) {
          const style = getComputedStyle(event.target);
          const borderColor = style.borderColor;
      
          event.target.style.boxShadow = `0 0 5px ${borderColor}`;
          event.target.style.backgroundColor = `${borderColor}`;
        }
      });
      

    document.addEventListener('mouseout', (event) => {
        if (
          event.target.classList.contains('raterNumber') &&
          event.target.classList.contains('raterNew') && !isAdmin()
        ) {
      
          if (
            (!selectedElement) ||
            (selectedElement && event.target?.textContent !== selectedElement?.textContent)
          ) {
            event.target.style.boxShadow = '';
            event.target.style.backgroundColor = '';
          }
        }
      });

    document.addEventListener('click', (event) => {
        if (
          event.target.classList.contains('raterNumber') &&
          event.target.classList.contains('raterNew') && !isAdmin()
        ) {
          const style = getComputedStyle(event.target);
          const borderColor = style.borderColor;
      
          selectedElement = event.target;
          selectedElement.style.boxShadow = `0 0 5px ${borderColor}`;
          selectedElement.style.backgroundColor = `${borderColor}`;
        }
      });
      
    useEffect(() => {
        window.addEventListener('resize', handleOrientationChange);

        return () => {
            window.removeEventListener('resize', handleOrientationChange);
        };
    }, []);

    useEffect(() => {
        getShareDetail(book_Pk, book_Id)
    }, [sharePayloads, book_Pk, book_Id])

    const handlePay = bid => {
        setpaydetail("");
        onOpen()
        var data = {
            booking_id: bid
        }
        axios({
            method: 'post',
            url: getAPIUrl('/api/payment/create/web/'),
            headers: {
                Authorization: getAuthToken(),
            },
            data: data,
            dataType: "json",
            cache: false,
        }).then(function (res) {
            setpaydetail(res.data);
        }).catch((error) => {
            catchError(error)
        })
    }

    const showEventDetails = (id) => {
        seteventDetailPopup(null);
        setopenEventDetail((cur) => !cur);
        const body = document.body
        body.classList.add("condBody")
        seteventDetailPopup(<div onClick={() => { setopenEventDetail(false); body.classList.remove("condBody") }} style={{ top: "0", left: "0", position: "fixed", zIndex: "20" }}>
            <div style={{ position: "fixed", height: "100vh", width: "100vw", backgroundColor: "rgba(0,0,0,0.6)", padding: "3%", display: "flex", justifyContent: "center", alignItems: "center" }}>

                {bookingDetail?.filter(obj => obj.booking_id?.includes(id)).map((obj, index) => {
                    return <>
                        <div onClick={(event) => { event.stopPropagation() }} className="booking-detail-panel" key={obj.booking_id}>
                            <button className='closeList' onClick={() => { setopenEventDetail(false); body.classList.remove("condBody") }}>&times;</button>
                            <div className="booking-detail-header">
                                <h3>Final Cost:  {!isAdmin() ? obj?.currency_symbol + obj?.actual_cost : CONST.MASKED_COST}</h3>
                            </div>
                            <div className="details-section">

                                {obj?.event_detail.map((val, index) => {
                                    return <>
                                        <fieldset key={index}>
                                            <legend>
                                                {val.subcategory}
                                            </legend>
                                            <Table >
                                                <Tbody>
                                                    <Tr>
                                                        <Th fontSize='lg'>Location</Th>
                                                        <Td fontSize='md'>{val.city}</Td>
                                                    </Tr>

                                                    <Tr>
                                                        <Th fontSize='lg'>Pricing basis</Th>
                                                        <Td fontSize='md'>{(val.is_per_day) ? "Daily" : ""}{(val.is_per_hour) ? "Hourly" : ""}</Td>
                                                    </Tr>

                                                    <Tr>
                                                        <Th fontSize='lg'>Duration</Th>
                                                        <Td fontSize='md'>Full Day</Td>
                                                    </Tr>

                                                    <Tr>
                                                        <Th fontSize='lg'>Services</Th>
                                                        <Td fontSize='md'>
                                                            {val.no_of_photographers > 0 ?
                                                                <>
                                                                    Photographers: {val.no_of_photographers} ({val.photographer_quality})
                                                                    {val.no_of_cinematographers > 0 ?
                                                                        <>
                                                                            <br /><br /></> : ""}
                                                                </>
                                                                : ""}
                                                            {val.no_of_cinematographers > 0 ?
                                                                <>
                                                                    Cinematographers:{val.no_of_cinematographers} ({val.cinematographer_quality})
                                                                </>
                                                                : ""}


                                                        </Td>
                                                    </Tr>
                                                    <Tr cn>
                                                        <Th fontSize='lg'>Details</Th>
                                                        <Td fontSize='md' className='venue-detail'>


                                                            {val.date_data.map((val, index) => {
                                                                return <>
                                                                    <li>
                                                                        <b>Date & time:</b> {val.date} At {val.time}
                                                                        {val.venue === "" ? "" : <br />}

                                                                        {val.venue === "" ? "" :
                                                                            <>
                                                                                <b>Venue:</b> {val.venue}
                                                                                {val.notes === "" ? "" : <br />}
                                                                            </>
                                                                        }
                                                                        {val.notes === "" ? "" :
                                                                            <>
                                                                                <b>Notes:</b> {val.notes}
                                                                            </>
                                                                        }
                                                                    </li>
                                                                </>
                                                            })}
                                                        </Td>
                                                    </Tr>
                                                </Tbody>
                                            </Table>
                                        </fieldset></>
                                })}

                            </div>
                        </div>
                    </>
                }
                )}
            </div>
        </div>)
    }

    const showPaymentHistory = (id) => {
        if(isAdmin()){
            return;
        }
        setPaymentHistoryBookingId(id);
        setopenpaymentHistory(true);
        const body = document.body;
        body.classList.add("condBody");
    };

    const bId = queryParams.get("id");

    const showShareDetails = () => {
        const bid = sharePayloads.bid
        const pk = sharePayloads.pk
        setopenShare(true);
        const shareData = shareDetailsArray[pk];
        const body = document.body
        sharePopup && body.classList.add("condBody")
        setLoading(false)
        shareData && setsharePopup(<div onClick={() => { setopenShare(false); body.classList.remove("condBody") }} style={{ top: "0", left: "0", position: "fixed", zIndex: "20" }}>
            <div style={{ position: "fixed", height: "100vh", width: "100vw", backgroundColor: "rgba(0,0,0,0.6)", padding: "3%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                {loading ? <>
                    {globalLoader()}
                </> : <>
                    <div onClick={(event) => { event.stopPropagation() }} className="shared-list">
                        <button className='closeList' onClick={() => { setopenShare(false); body.classList.remove("condBody") }}>&times;</button>
                        {shareData?.shared_array?.map((shareDetail) => {
                            return <>
                                <li key={shareDetail.share_url}>
                                    <div className="shared-link">
                                        <a style={{ color: shareDetail.is_disabled && "rgb(153, 153, 153", textDecoration: shareDetail.is_disabled && "line-through", cursor: shareDetail.is_disabled && "not-allowed", pointerEvents: shareDetail.is_disabled && "none" }} href={shareDetail.is_disabled ? '' : shareDetail.share_url} className="shared-link-text" target='_blank'>https://..{shareDetail.share_url?.substring(shareDetail.share_url.length - 11, shareDetail.share_url.length)}</a>
                                        <CopyButton value={shareDetail} />
                                    </div>

                                    <div className="shared-btns">
                                        {bookingDetail?.filter(obj => obj.booking_id?.includes(bid)).map(obj => (
                                            <button style={{ backgroundColor: shareDetail.is_disabled && "rgb(153, 153, 153" }} disabled={shareDetail.is_disabled} className="regen" onClick={() => { !isAdmin() && regenerate(shareDetail.share_passcode, pk, bid) }}><TfiReload /><span className='regenText'>Regenerate</span></button>
                                        ))}


                                        <button style={{ backgroundColor: shareDetail.is_disabled && "black" }} className={shareDetail.is_disabled ? "fa-solid fa-check" : "disable"} onClick={() => { !isAdmin() && disableShareURL(shareDetail.share_passcode, shareDetail.is_disabled, pk, bid) }}><BiUnlink /><span className='disText'>{shareDetail.is_disabled ? "Enable" : "Disabled"}</span></button>
                                        <Link target='_blank' onClick={() => openExternalApp(`${getWhatsappShareUrl(shareDetail.share_msg)}`)}><button style={{ backgroundColor: shareDetail.is_disabled && "rgb(153, 153, 153" }} disabled={shareDetail.is_disabled} className="share" ><FaWhatsapp /><span className='shareText'>Share</span></button></Link>
                                        <ShareButton className="share-everywhere" url={shareDetail.share_url || shareDetail.share_url} title={"Share"} />

                                    </div>
                                    <div
                                        style={{
                                            display: 'inline-flex',
                                            color: '#6c757d',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            fontStyle: 'italic',
                                            margin: '5px',
                                            whiteSpace: 'nowrap',
                                            width: '70px'
                                        }}
                                    >
                                        <span>{shareDetail.share_tag}</span>
                                    </div>
                                </li>
                            </>
                        })}
                    </div></>}
            </div>
        </div>)
        setLoading(false);
    }

    useEffect(() => {
        const getBookingDetails = async (bide) => {
            const index = bookingDetail.findIndex((item) => item.booking_id === bide);
            if (index !== -1) {
                return;
            }

            try {
                const response = await axios.post(
                    getAPIUrl('/api/booking/get_detail/v2/'),
                    { booking_id: bide },
                    {
                        headers: { Authorization: getAuthToken() },
                    }
                );

                const data = response.data.booking_detail;
                data.booking_id = bide;

                setbookingDetail((prev) => [...prev, data]);

            } catch (error) {
                catchError(error)
            }
        };
        const promises = bookings?.map((dd) => getBookingDetails(dd.booking_id));
        if (promises?.length) {
            Promise.allSettled(promises).then(() => {
                setbookingDetail((prev) =>
                    prev.filter(
                        (item, index, arr) =>
                            arr.findIndex((t) => t.booking_id === item.booking_id) === index
                    )
                );
            });
        }

    }, [bookings]);

    useEffect(() => {
        const bid = getQueryVariable('id');
        let idx;
        if (bid === null) {
            idx = 0;
        } else {
            idx = bookings.findIndex(obj => obj.booking_pk == bid);
            if (idx === -1 && bookings.length > 0) {
                // Navigate to the first booking's id
                navigate(`/?id=${bookings[0].booking_pk}`);
            }

            if (idx === -1) {
                idx = 0;
            }
        }
        setOpenedTabIndex(idx);
    }, [bookings]);

    useEffect(()=>{
        setNavigationHistory(location, CONST.DASHBOARD)
    },[])

    useEffect(() => {
        setShowAppBanner(shouldShowPlayStoreInstallBanner({ hasContent: Boolean(bookings?.length) }));
    }, [bookings, dashWidth]);

    const regenerate = async (pass, bookingPk, bid) => {
        if (!window.confirm("The existing link will be deactivated and a new link will be generated.\nAre you sure that you want to generate a new link?")) {
            return;
        }
        try {
            const sharedData = {
                action_flag: 'regenerate',
                share_passcode: pass,
            };

            const response = await fetch(getAPIUrl(`/api/share/url/${bookingPk}/`), {
                method: 'PUT',
                headers: {
                    Authorization: getAuthToken(),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(sharedData),
            });

            const res = await response.json();


            if (res.success) {
                setLoading(false)

                for (let index = 0; index < shareDetailsArray[bookingPk].shared_array.length; index++) {
                    if (shareDetailsArray[bookingPk].shared_array[index].share_passcode === pass) {
                        shareDetailsArray[bookingPk].shared_array[index].share_passcode = res.share_passcode
                        shareDetailsArray[bookingPk].shared_array[index].share_url = res.share_url
                        shareDetailsArray[bookingPk].shared_array[index].share_msg = res.share_msg
                        break
                    }
                }
                getShareDetail(bookingPk, bid)
            } else {
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
            console.error('API request failed:', error);

        }
    };

    const getPhType = (event) => {
        return getPhEventType(pages.dashboard, event)
    }

    const disableShareURL = (pass, is_disabled, bookingPk, bid) => {
        var passcode = pass;
        var shared_data = {
            action_flag: 'deactivate',
            share_passcode: passcode,
            is_disabled: !is_disabled,
        };

        const config = {
            method: "PUT",
            url: getAPIUrl(`/api/share/url/${bookingPk}/`),
            headers: {
                Authorization: getAuthToken(),
            },
            data: shared_data,
            dataType: "json",
            contentType: "application/json; charset=utf-8",
        };
        axios(config)
            .then((response) => {
                for (let index = 0; index < shareDetailsArray[bookingPk].shared_array.length; index++) {
                    if (shareDetailsArray[bookingPk].shared_array[index].share_passcode === pass) {
                        shareDetailsArray[bookingPk].shared_array[index].is_disabled = response.data.is_disabled
                        break
                    }
                }
                getShareDetail(bookingPk, bid)
            })
            .catch((error) => {
                catchError(error)
            });
    };
    const alert = <AlertDialog
        onClose={() => { setonOpenAlert(false) }}
    >
        <AlertDialogOverlay>
            <AlertDialogContent>
                <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                    Delete Customer
                </AlertDialogHeader>

                <AlertDialogBody>
                    Are you sure? You can't undo this action afterwards.
                </AlertDialogBody>

                <AlertDialogFooter>
                    <button ref={cancelRef} onClick={() => { setonOpenAlert(false) }}>
                        Cancel
                    </button>
                    <button colorScheme='red' onClick={() => { setisRegConfirm(true) }} ml={3}>
                        Confirm
                    </button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialogOverlay>
    </AlertDialog>;
    const id = queryParams.get('id')
    useEffect(() => {
        // if(bookings?.length == 0){   INSTA changes
        //     fetchInstagramPosts().then(data => setInstaPosts(data));
        // }
        bookings.length > 0 && !id && navigate(`/?id=${bookings[0].booking_pk}`)
        const element = document.getElementById(id)
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }, [bookings])

    useEffect(() => {

    }, [id])

    return (
        <>
            {isLoggedin ?
                <div className="dashboard">

                    {feedback.rating !== null && selectedBookingForRating && (
                        <div
                            style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100vw',
                            height: '100vh',
                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 9999,
                            }}
                        >
                            <div
                            className="feedbackDiv"
                            style={{
                                border: `2px solid ${get_platform_bg_color()}`,
                                backgroundColor: 'white',
                                padding: '30px',
                                borderRadius: '10px',
                                width: '90%',
                                maxWidth: '500px',
                                position: 'relative',

                            }}
                            >

                        <AiOutlineClose style={{position: 'absolute', top:'5px', right:'8px', fontWeight: '900', fontSize: '1.5rem', cursor: 'pointer'}} onClick={handleFeedbackClose} />


                            <h2 style={{ marginBottom: '10px', textAlign: 'center' }}>
                                {selectedBookingForRating.booking_name}
                            </h2>

                            <hr />

                            <h3 style={{ marginBottom: '10px', marginTop: '10px', textAlign: 'center' }}>
                                {selectedBookingForRating.nps_list.find(item => item.score === 0)?.rating_ques}
                            </h3>

                        <div className="rateDiv" style={{marginBottom: '10px'}}>
                                        <div style={{ display: "flex", gap: "5px" }}>
                                        {[...Array(10).keys()].map((num) => {
                                            const rating = num + 1;
                                            const isSelected = feedback.rating == rating;
                                            const isEditable = true;

                                            return (
                                            <div
                                                key={rating}
                                                onClick={() => {
                                                if (isEditable && !isAdmin()) {
                                                    setFeedback(prev => ({
                                                        ...prev,
                                                        rating: rating, 
                                                      }));
                                                }
                                                }}
                                                className="raterNumber raterNew"
                                                data-fdbkid={bId}
                                                style={{
                                                border: (currentDimensions > 1200 ? `3px solid hsl(${(rating - 1) * 12}, 100%, 50%)` : `2px solid hsl(${(rating - 1) * 12}, 100%, 50%)`),
                                                backgroundColor: isSelected ? `hsl(${(rating - 1) * 12}, 100%, 50%)` : "white",
                                                cursor: isEditable ? "pointer" : "not-allowed",
                                                opacity: isEditable ? 1 : 0.6,
                                                }}
                                            >
                                                {rating}
                                            </div>
                                            );
                                        })}
                                        </div>
                                    </div>


                            <textarea
                                placeholder="Feedback (Optional)"
                                className="feedbackInput"
                                style={{
                                width: '100%',
                                minHeight: '100px',
                                padding: '10px',
                                fontSize: '1rem',
                                borderRadius: '8px',
                                border: '1px solid #ccc',
                                resize: 'vertical',
                                }}
                                value={feedback.feedbackText}
                                onChange={(e) => setFeedback(prev => ({
                                    ...prev,
                                    feedbackText: e.target.value
                                }))}
                            />
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                                <button
                                onClick={!isAdmin() && handleFeedbackSubmit}
                                ph-type={getPhType(posthogEvents["submit-feedback"])}
                                className={phTrack}
                                booking_id={bId}
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: get_platform_bg_color(),
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    fontWeight: 'bold',
                                }}
                                >
                                Submit
                                </button>
                            </div>
                            </div>
                        </div>
                        )}
                        {showGooglePopup && (
                            <GoogleRatingPopup setShowGooglePopup={setShowGooglePopup} />)}

                    <Navbar title={"Dashboard"} location={token_url(`${process.env.REACT_APP_STAG_URL}`)} />
                    {showAppBanner && (
                        <Banner
                            bgColor={get_platform_bg_color()}
                            title="Open in EventGraphia App"
                            subtitle="Faster browsing and a smoother viewing experience."
                            showActionButton
                            actionLabel="Open"
                            onAction={openPlayStoreOrInstallApp}
                            onClose={() => dismissPlayStoreInstallBanner(() => setShowAppBanner(false))}
                        />
                    )}
                    <div>
                        <WorkDetailHeader tabClick={handleActivity} currentPage={currentPage} activityTab={activityTab} postHogPage={pages.dashboard}/>
                    </div>
                    {loading ?
                        <div className='fullpage-overlay'>
                            {globalLoader()}
                        </div> :

                        <Accordion allowToggle className='accordion' ref={divRef} index={openedTabIndex} >
                            {(bookings?.length === 0) ?

                                <>
                                    <div className="no-bookings">
                                        <div className="no-booking-header">
                                            <h2>No Bookings Found</h2>
                                        </div>
                                        <div className="callback-section">
                                            <h3>Want to get your first event booked?</h3>
                                            <button className='filled-btn' onClick={() => { window.location = token_url(`${process.env.REACT_APP_STAG_URL}/booking`) }}><MdPhoneCallback />Request a Quote</button>
                                        </div>
                                        <div className="eventgraphia-data">
                                            <div className="box-data">

                                                <span><BiUserCheck /></span>
                                                <p>Shot 1,000+ wedding related events</p>
                                            </div>
                                            <div className="box-data">

                                                <span><MdOutlineAddPhotoAlternate /></span>
                                                <p>Shot 4+ million photos</p>
                                            </div>
                                            <div className="box-data">

                                                <span><AiOutlineVideoCameraAdd /></span>
                                                <p>Shot 300,000 minutes of videos</p>
                                            </div>
                                            <div className="box-data">

                                                <span><FaPhotoVideo /></span>
                                                <p>Generated 125+ TB of pictures & videos</p>
                                            </div>
                                        </div>
                                        {/* <div className="wrapper">   INSTA changes
                                            <h3>AWARDS</h3>
                                            {isMobile ? (
                                                <div className="scroller-wrapper">
                                                <motion.div
                                                    className="scroller"
                                                    ref={containerRef}
                                                    initial={{ x: 0 }}
                                                    animate={{ x: `-${100 * images.length}%` }}
                                                    transition={{ 
                                                    repeat: Infinity, 
                                                    duration: 300, 
                                                    ease: "linear" 
                                                    }}
                                                >
                                                    {Array.from({ length: 100 }, () => images).flat().map((src, index) => (
                                                    <img key={index} src={src} alt="scrolling" className="image" />
                                                    ))}
                                                </motion.div>
                                                </div>
                                            ) : (
                                                <div className="static-images">
                                                {images.map((src, index) => (
                                                    <img key={index} src={src} alt="static" className="image" />
                                                ))}
                                                </div>
                                            )}
                                        </div>
                                        <div className='insta-feed'>    INSTA changes
                                            {instaPosts?.length > 0 && <img src="https://res.cloudinary.com/dap7xejim/image/upload/v1738305613/pngegg_kgzdoq.png" alt="insta logo" className='insta-logo' />}
                                        {instaPosts && <InstaImageGrid instaResp={instaPosts} />}
                                        </div> */}
                                    </div>

                                </> :

                                <>
                                    {bookings?.map((dd, index) => {
                                        return <>
                                            <React.Fragment key={dd.booking_id}>
                                                <AccordionItem isDisabled={!(dd?.work_list?.length > 0) && bookingDetail?.find(obj => obj.booking_id?.includes(dd.booking_id) && (obj.payment_detail.length === 0 && obj?.estimations?.length === 0))}>
                                                    <h2 style={{ display: "flex", flexDirection: 'column', alignItems: "flex-start" }}>
                                                        
                                                        <AccordionButton _hover={{ background: "transparent" }}>
                                                            <Card id={dd.booking_pk} style={{ width: "100%", display: "flex", textAlign: "center", padding: "20px", position: 'relative',  }} as="span" onClick={() => { setOpenedTabIndex(index); setCurrId(dd.booking_id); navigate('/?id=' + dd.booking_pk); }} flex='1' textAlign='left' className="accordion-heading">

                                                                {dd.nps_list.length > 0 && dd.nps_list.find(item => item.score === 0) &&
                                                                !(!(dd?.work_list?.length > 0) && bookingDetail?.find(obj => obj.booking_id?.includes(dd.booking_id) && (obj.payment_detail.length === 0 && obj?.estimations?.length === 0))) && (

                                                                    <>

                                                                    <div style={{ display: "flex", flexDirection: (currentDimensions > 1200 ? "row" : "column"), alignItems: "center", position:'absolute', top: '0', left:'0', right:'0', borderTopLeftRadius: 'inherit',
                                                                        borderTopRightRadius: 'inherit', borderBottomLeftRadius: 0, borderBottomRightRadius: 0, fontSize: (currentDimensions > 1200 ? '18px':'0.9rem'), fontWeight:'bold', padding: '10px 20px', color: 'white', zIndex: 1, justifyContent: 'space-evenly', gap: '0.7rem', borderBottom: "0.5px solid rgba(0, 0, 0, 0.2)", boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)" }}>
                                                                            <span style={{color: 'rgb(159, 120, 102)'}}>{dd.nps_list.find(item => item.score === 0)?.rating_ques}</span>
                                                                            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                                                            {[...Array(10).keys()].map((num) => {
                                                                                const rating = num + 1;
                                                                                const isSelected = feedback.rating == rating && dd.booking_pk == bId;

                                                                                return (
                                                                                <div
                                                                                    key={rating}
                                                                                    onClick={(e) => {
                                                                                        if(isAdmin()){
                                                                                            return
                                                                                        }
                                                                                        setSelectedBookingForRating(dd)
                                                                                        selectedElement = e.target;
                                                                                        setFeedback(prev => ({
                                                                                            ...prev,
                                                                                            rating: rating,
                                                                                        }));
                                                                                    }}
                                                                                    className="raterNumber raterNew"
                                                                                data-fdbkid={dd.booking_pk}
                                                                                    style={{
                                                                                    border: (currentDimensions > 1200 ? `3px solid hsl(${(rating - 1) * 12}, 100%, 50%)` : `2px solid hsl(${(rating - 1) * 12}, 100%, 50%)`),
                                                                                    backgroundColor: isSelected ? `hsl(${(rating - 1) * 12}, 100%, 50%)` : "white",
                                                                                    cursor: "pointer",
                                                                                    opacity: 1 ,
                                                                                    marginLeft: '0.25rem',
                                                                                    width: (currentDimensions > 1200 ? '35px' : '25px'),
                                                                                    height: (currentDimensions > 1200 ? '30px' : '25px'),
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    }}
                                                                                >
                                                                                    {rating}
                                                                                </div>
                                                                                );
                                                                            })}
                                                                            </div>
                                                                        </div>
                                                                        
                                                                        <div style={{ height: (currentDimensions > 1200 ? '3.5rem': '5.5rem') }} />
                                                                    </>

                                                                )}
                                                                <Badge mr='2' className='booking-status-badge' fontSize='0.8em' colorScheme='green'>
                                                                    {dd.booking_status}
                                                                </Badge>
                                                                <p className='booking-id'>{dd.booking_name}</p>
                                                                <FormsTile
                                                                    creative={dd?.creative_preference}
                                                                    weddingDay={dd?.wedding_day}
                                                                    whatToExpect={dd?.what_to_expect}
                                                                />
                                                                <AccordionIcon className='dropAlbum' />
                                                            </Card>
                                                        </AccordionButton>
                                                    </h2>
                                                    <AccordionPanel pb={4}>

                                                        <Divider orientation='horizontal' />

                                                        <div className={(dd?.work_list?.length === 1) ? "single-deliverable-main" : "main-container-del"}>
                                                            {dd?.work_list?.length > 0 ? <div className={(dd?.work_list?.length === 1) ? "single-deliverable" : "deliverables"}>
                                                                {dd.work_list?.map((wl, index) => {

                                                                    return <>
                                                                        <Link className={phTrack} ph-type={getPhType(posthogEvents['deliverable-item'])} booking_id={bId} deliverable_id={wl.id} deliverable_name={wl.name} to={token_url(wl.url)} key={wl.url}>
                                                                            <Card maxW='md' className='del-cards' position={'relative'}>
                                                                                <Image
                                                                                    objectFit='cover'
                                                                                    src={wl.cover_url}
                                                                                    className='del-card-img'
                                                                                />
                                                                                <div className="card-overlay-deliverable"></div>
                                                                                <h3 className="card-text-overlay">{wl.name}</h3>
                                                                            </Card>
                                                                        </Link>
                                                                    </>
                                                                })}
                                                            </div> : ""}

                                                            {bookingDetail.length > 1 ? <div className={(dd?.work_list?.length === 1) ? "single-deliverable-tab" : "booking-detail-tab"}>
                                                                {/* {bookingDetail?.filter(obj => obj.booking_id?.includes(dd.booking_id) && (obj?.my_work_detail_web[0]?.actions[0]?.action_type === "VIEW_DRAFTS")).map(obj => (
                                                                    <Link to={'/album-selection?id=' + dd.booking_id} key={obj.booking_pk} className='hollow-btn tab-btn grid-item'><MdOutlinePhotoSizeSelectLarge />Album Selection</Link>
                                                                ))} */}
                                                                {/* {bookingDetail?.filter(obj => obj.booking_id?.includes(dd.booking_id) && (obj.is_share_url_exist === true)).map(obj => (
                                                                    <button key={obj.booking_pk} className='hollow-btn tab-btn grid-item' onClick={() => { getShareDetail(obj.booking_pk, dd.booking_id) }}><HiOutlineShare />Shared Url List</button>
                                                                ))} */}


                                                                {bookingDetail?.filter(obj => obj.booking_id?.includes(dd.booking_id) && (obj.payment_detail.length > 0)).map(obj => (
                                                                    <button className={`hollow-btn tab-btn grid-item ${phTrack}`} ph-type={getPhType(posthogEvents["payment-history"])} booking_id={bId} key={obj.booking_pk} onClick={() => { showPaymentHistory(dd.booking_id) }}><MdOutlinePayment />Payment History</button>
                                                                ))}

                                                                {
                                                                    dd?.nps_list.length > 0 && <button className={`hollow-btn tab-btn grid-item ${phTrack}`} ph-type={getPhType(posthogEvents['your-feedback'])} booking_id={bId} onClick={() => {!isAdmin() && navigate('/ratings/?id=' + dd.booking_pk) }}><GiStarsStack style={{fontSize: '1.5rem'}} /> Your Feedback</button>
                                                                }


                                                                {bookingDetail?.filter(obj => obj.booking_id?.includes(dd.booking_id) && (obj.event_detail.length > 0 && !obj.estimations)).map(obj => (
                                                                    <button className={`hollow-btn tab-btn grid-item ${phTrack}`} ph-type={getPhType(posthogEvents['event-detail'])} booking_id={bId} key={obj.booking_pk} onClick={() => { showEventDetails(dd.booking_id) }}><MdOutlineLibraryBooks />Event Detail</button>
                                                                ))}


                                                            </div> :
                                                                <div style={{ display: "flex", justifyContent: "center" }}>
                                                                    {globalLoader()}
                                                                </div>
                                                            }
                                                        </div>
                                                        {bookingDetail.length > 1 && <div style={{ display: "flex", flexDirection: "column" }}>
                                                            {bookingDetail?.filter(obj => obj.booking_id?.includes(dd.booking_id) && (obj.estimations && obj.estimations.length > 0)).map(obj => (
                                                                <>
                                                                    <div style={{ display: obj.paid_amount === null && "none", fontSize: dashWidth < 600 ? "normal" : "large", fontWeight: "bold" }}>
                                                                        <div style={{ padding: "0.7rem 0" }}>Total amount paid : {!isAdmin() ? obj.paid_amount : CONST.MASKED_COST}</div>
                                                                        <Divider orientation='horizontal' />
                                                                    </div>
                                                                </>
                                                            ))}
                                                        </div>}

                                                        {bookingDetail.length > 1 && <div style={{ display: "flex", justifyContent: "center" }}>
                                                            {bookingDetail?.filter(obj => obj.booking_id?.includes(dd.booking_id) && (obj.estimations && obj.estimations.length > 0)).map(obj => (
                                                                <>
                                                                    <div className='multipleEst' style={{ width: obj.estimations.length === 1 && dashWidth >= 700 && "90%", marginTop: "10px" }}>
                                                                        {bookingDetail?.filter(obj => obj.booking_id?.includes(dd.booking_id) && (obj.estimations.length > 0)).map(obj => (
                                                                            <>
                                                                                {obj.estimations.map((e, index) => {
                                                                                    return <>
                                                                                        {(obj.estimations.length > 1 || dashWidth < 700) && <Link className={phTrack} ph-type={getPhType(posthogEvents['view-estimation'])} booking_id={bId} estimation_id={e.id} to={isAdmin() ? '#' : e.url} key={e.url} >
                                                                                            <Card maxW='12rem' style={{ border: index === 0 && obj.estimations.length > 1 && "5px solid #C6F6D5", fontSize: "0.9rem", marginRight: index < obj.estimations.length - 1 && "1.3rem" }}>
                                                                                                <div style={{ margin: "15px" }}>
                                                                                                    <div style={{ paddingBottom: "7px", display: "flex", justifyContent: "space-between", alignItems: "center" }}><span>{quotation_string(e.version)[0]} <span style={{ fontWeight: "bold" }}>{quotation_string(e.version)[1]}</span></span><span style={{ display: !e.is_final && "none", border: "1px solid #aa8440", padding: "0 2px", borderRadius: "2rem", color: "white", backgroundColor: "#aa8440", padding: "0 10px", fontSize: "smaller" }}>Final</span></div>
                                                                                                    <div style={{ paddingBottom: "7px", textAlign: "left" }}>Created : <span style={{ fontWeight: "bold" }}>{e.created_on}</span></div>
                                                                                                    <div style={{ textAlign: "left" }}>Cost : <span style={{ fontWeight: "bold" }}>{!isAdmin() ? e.cost : CONST.MASKED_COST}</span> </div>
                                                                                                </div>
                                                                                                <div style={{ display: "flex", justifyContent: "center" }}>
                                                                                                    <div style={{ border: "2px solid black", width: "fit-content", margin: "0 15px 15px 15px", padding: "5px 20px", borderRadius: "10px" }}>View</div>
                                                                                                </div>
                                                                                            </Card>
                                                                                        </Link>}
                                                                                        {(obj.estimations.length === 1 && dashWidth >= 700) && <Link className={phTrack} ph-type={getPhType(posthogEvents['view-estimation'])} booking_id={bId} estimation_id={e.id} style={{ width: obj.estimations.length === 1 && dashWidth >= 700 && "100%" }} to={isAdmin() ? '#' : e.url} key={e.url}>
                                                                                            <Card minW='100%' style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", padding: "0 10%", width: "fit-content" }}>
                                                                                                <div style={{ margin: "15px", display: "flex", flexDirection: "row", alignItems: "center" }}>
                                                                                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingRight: "1.5rem" }}><span style={{ paddingRight: "1rem" }}>{quotation_string(e.version)[0]} <span style={{ fontWeight: "bold" }}>{quotation_string(e.version)[1]}</span></span><span style={{ display: !e.is_final && "none", border: "1px solid #aa8440", padding: "0 2px", borderRadius: "2rem", color: "white", backgroundColor: "#aa8440", padding: "0 10px", fontSize: "smaller" }}>Final</span></div>
                                                                                                    <div style={{ paddingRight: "1.5rem" }}>Created : <span style={{ fontWeight: "bold" }}>{e.created_on}</span></div>
                                                                                                    <div style={{ paddingRight: "1.5rem" }}>Cost : <span style={{ fontWeight: "bold" }}>{!isAdmin() ? e.cost : CONST.MASKED_COST}</span> </div>
                                                                                                </div>
                                                                                                <div style={{ display: "flex", justifyContent: "center" }}>
                                                                                                    <div style={{ border: "2px solid black", width: "fit-content", margin: "15px", padding: "5px 20px", borderRadius: "10px" }}>View</div>
                                                                                                </div>
                                                                                            </Card>
                                                                                        </Link>}
                                                                                    </>
                                                                                })}
                                                                            </>
                                                                        ))}
                                                                    </div>
                                                                </>
                                                            ))}
                                                        </div>}
                                                        {(openShare === true) ? sharePopup : ""}

                                                        {onOpenAlert ? alert : ""}

                                                        {(openEventDetail === true) ? eventDetailPopup : ""}

                                                        {(openpaymentHistory === true) ? (
                                                          <Popup
                                                            isOpen={true}
                                                            onClose={() => {
                                                              setopenpaymentHistory(false);
                                                              document.body.classList.remove("condBody");
                                                            }}
                                                          >
                                                            <table className="payment-history-table">
                                                              <thead>
                                                                <tr className='payment-history-table-head'>
                                                                  <th>Status</th>
                                                                  <th>Cost</th>
                                                                  <th>Transaction ID</th>
                                                                  <th>Receipt</th>
                                                                </tr>
                                                              </thead>
                                                              <tbody>
                                                                {bookingDetail?.filter(obj => obj.booking_id?.includes(paymentHistoryBookingId)).map(obj =>
                                                                  obj.payment_detail?.map((x, index) => (
                                                                    <tr key={index} className="payRes">
                                                                      <td>
                                                                        <span
                                                                          style={{
                                                                            padding: window.innerWidth > 600 ? "5px 10px" : "3px",
                                                                            borderRadius: "5px",
                                                                            backgroundColor: x.status === "Success" ? "green" : "gray",
                                                                            color: "white",
                                                                            fontSize: "1em",
                                                                            fontWeight: "bold",
                                                                          }}
                                                                        >
                                                                          {x.status}
                                                                        </span>
                                                                      </td>
                                                                      <td style={{fontSize:'1em'}}>{x.currency_symbol + x.amount}</td>
                                                                      <td className='payment-table-transaction-cell'>
                                                                        {x.transaction_id}
                                                                      </td>
                                                                      <td>
                                                                        <button
                                                                          style={{
                                                                            padding: window.innerWidth > 600 ? "8px 16px" : "4px",
                                                                            border: "none",
                                                                            borderRadius: "4px",
                                                                            cursor: x.installment_id && !downloadingReceiptId ? "pointer" : "not-allowed",
                                                                            fontWeight: window.innerWidth < 600 && "bold"
                                                                          }}
                                                                          disabled={!x.installment_id || Boolean(downloadingReceiptId)}
                                                                          onClick={() => handleDownloadReceipt(x.installment_id, x.filename)}
                                                                        >
                                                                          {downloadingReceiptId === x.installment_id ? globalLoader('md') : (
                                                                            <img src={DownloadIcon} alt="Download" style={{height: "1rem", width: "1rem"}} />
                                                                          )}
                                                                        </button>
                                                                      </td>
                                                                    </tr>
                                                                  ))
                                                                )}
                                                              </tbody>
                                                            </table>
                                                          </Popup>
                                                        ) : ""}

                                                    </AccordionPanel>
                                                </AccordionItem>
                                            </React.Fragment>
                                        </>
                                    })}
                                </>
                            }
                        </Accordion>
                    }

                    {showToast && <Toast message={toastMessage} duration={toastMessage?.hide_in} onClose={() => setShowToast(false)}/>}

                </div>

                :
                <div className='fullpage-overlay'>
                    {globalLoader()}
                </div>
                
            }
            

            {/* {isInstaPopupOpen && (  INSTA changes
                <Popup isOpen={isInstaPopupOpen} onClose={() => {setIsInstaPopupOpen(false); setClickedInstaPost(null)}}>
                    <InstagramEmbed url={clickedInstaPost} />
                </Popup>
            )} */}

        </>

    )

}

// document.head.insertAdjacentHTML("beforeend", `<style>${awardStyles}</style>`);  INSTA changes

export default Dashboard